<template>
  <section class="page-creator pt-3">
    <div class="container">
      <div class="row">
        <div class="col-8 m-auto">
          <header class="mb-3">
            <h4 class="rtl text-right font-22">بیوگرافی</h4>
          </header>
        </div>
        <div class="col-8 m-auto">
          <instructor/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import instructor from 'cp/instructor'

export default {
  name: 'page-creator',
  components: {
    instructor
  },
  data() {
    return {
    }
  },
  created() {
    this.getCreator()
  },
  destroyed() {
    this.$store.commit("courses/SET_DATA", { data: null, id: "instractor" });
    this.$store.commit('courses/clear')
  },
  methods: {
    async getCreator() {
      this.$store.dispatch('courses/getInstractor', this.$route.params.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/user/_id.vue